import React from 'react'
import PreviewTitleDescription from './PreviewTitleDescription'
import { PanoPlayer } from 'aria-viewer/common/components/PanoPlayer'
import injectSheet from 'react-jss'
import { Preload } from 'react-preloaded'
import compose from 'recompose/compose'
import withProps from 'recompose/withProps'

const style = theme => ({
    wrapper: {
        height: '100%',
        width: '100%',
    },
})

const props = withProps(({ mediaUrl }) => ({
    largeSourceURL: mediaUrl.largeSourceURL,
    smallSourceURL: mediaUrl.smallSourceURL,
}))

const panoPlayer = ({ sourceURL, width, height, enableInteractions = false, autoRotate = true }) => (
    <PanoPlayer
        sourceURL={sourceURL}
        width={width}
        height={height}
        enableInteractions={enableInteractions}
        autoRotate={autoRotate}
    />
)

const PanoPreview = ({
    title,
    classes,
    description,
    largeSourceURL,
    smallSourceURL,
    height,
    width,
    offsetX,
    offsetY,
}) => (
    <div className={classes.wrapper}>
        <PreviewTitleDescription
            title={title}
            description={description}
            leftOffset={410}
            isVisible={true}
            offsetX={offsetX}
            offsetY={offsetY}
        />
        <Preload loadingIndicator={panoPlayer({ sourceURL: smallSourceURL, width, height })} images={[largeSourceURL]}>
            {panoPlayer({ sourceURL: largeSourceURL, width, height })}
        </Preload>
    </div>
)

export default compose(
    injectSheet(style),
    props
)(PanoPreview)
